export class OrganizationInfo {
  id: string;
  name: string;
  domain: string[];
  domainNumber: number;
  userNumber: number;
  groupNumber: number;
  resourceNumber: number;
  sequenceNumber: number;
  version: number;
  organizationType: string;
  userSubscriptionInfo: SubscriptionInfoModel | null;
  isDeleted: boolean = false;
  adTenantId: string;

  constructor(data?: Record<string, any>) {
    this.id = data?.id || "";
    this.name = data?.name || "";
    this.domain = data?.domain || [];
    this.domainNumber = data?.domainNumber || 0;
    this.userNumber = data?.userNumber || 0;
    this.groupNumber = data?.groupNumber || 0;
    this.resourceNumber = data?.resourceNumber || 0;
    this.sequenceNumber = data?.sequenceNumber || 0;
    this.version = data?.version || 0;
    this.organizationType = data?.organizationType || "";
    this.userSubscriptionInfo = new SubscriptionInfoModel(data?.userSubscriptionInfo);
    this.adTenantId = data?.adTenantId || "";
    this.isDeleted = !!data?.isDeleted;
  }
}

export class SubscriptionInfoModel {
  expiredDateTime: string;
  subscriptionId: string;
  triggerTime: string;

  constructor(data?: Record<string, any>) {
    this.expiredDateTime = data?.expiredDateTime || "";
    this.subscriptionId = data?.subscriptionId || "";
    this.triggerTime = data?.triggerTime || "";
  }
}